import { HubSetting } from 'hs-resources/resources/HubSetting';
import { skipToken } from 'pulse/react';

import { useHttpResource } from '../../client/useHttpResource';
import { UseAsyncFunctionOptions } from '../../utils/hooks/useAsyncFunction';

export type SavingMode = 'auto' | 'manual';

const DEFAULT_SAVING_MODE: SavingMode = 'auto';

export const useSavingMode = (options: UseAsyncFunctionOptions = {}) => {
  const { data, loading, error } = useHttpResource(HubSetting, {
    params: options.skip
      ? skipToken
      : { settingName: 'CRM:Properties:AutosaveMode' },
  });

  const savingMode: SavingMode =
    data === 'auto' || data === 'manual' ? data : DEFAULT_SAVING_MODE;

  return { data: savingMode, loading, error };
};
